// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loginForm_form__AR0O2 {
  max-width: 360px;
  margin: 100px auto;
  padding: 32px 40px;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}

.loginForm_logo__bYz8Y {
  width: 140px;
  object-fit: contain;
  margin: 0 auto 32px auto;
  display: block;
}

.loginForm_title__z4YAH {
  text-align: center;
  color: rgba(33, 33, 33, 1);
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 24px;
}

.loginForm_input__SKRZ5 {
  width: 100%;
  padding: 12px;
  border: 1px solid rgba(203, 213, 225, 1);
  border-radius: 8px;
  font-size: 15px;
  transition: border-color 0.2s;
  text-align: left;
  background-color: none;
  margin-bottom: 24px;
}
.loginForm_inputs__QHdVf {
  width: 100%;
  padding: 12px;
  border: 1px solid rgba(203, 213, 225, 1);
  border-radius: 8px;
  font-size: 15px;
  transition: border-color 0.2s;
  text-align: left;
  background-color: none;
}
.loginForm_inputSecond__LYhDv {
  width: 100%;
  padding: 12px;
  border: 1px solid rgba(203, 213, 225, 1);
  border-radius: 8px;
  font-size: 15px;
  transition: border-color 0.2s;
  text-align: left;
  background-color: none;
  margin-bottom: 8px;
}

.loginForm_input__SKRZ5:focus {
  border-color: #2e7d32;
  background-color: #fff;
  outline: none;
}

.loginForm_button__8898g {
  padding: 12px;
  background-color: rgba(24, 160, 88, 1);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-bottom: 32px;
}

.loginForm_button__8898g:hover {
  background-color: #1b5e20;
}

.loginForm_error__PQnV1 {
  color: red;
  font-size: 14px;
  text-align: left;
  margin-top: -2px;
  margin-bottom: 10px;
}

::placeholder {
  color: rgba(201, 201, 205, 1);
}

.loginForm_forgetPassword__hK\\+mM {
  text-align: right;
  font-size: 14px;
  color: rgba(115, 115, 115, 1);
  margin-bottom: 20px;
  cursor: pointer;
}

.loginForm_register__D90yr {
  color: rgba(24, 160, 88, 1);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

/* Контейнер для уведомлений по центру снизу */
.loginForm_toast-container__Ju0dK {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  gap: 10px; /* расстояние между уведомлениями */
  align-items: center; /* центрируем уведомления */
  z-index: 9999;
}

/* Базовый стиль уведомления */
.loginForm_toast__OAMN3 {
  min-width: 300px;
  max-width: 400px;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 500;
  color: #fff;
  opacity: 0;
  animation: loginForm_slideToast__rBdIC 4.5s forwards;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

/* Ошибка */
.loginForm_toast__OAMN3.loginForm_error__PQnV1 {
  background-color: rgba(255, 59, 48, 1);
}

/* Успех */
.loginForm_toast__OAMN3.loginForm_success__123Zq {
  background-color: rgba(24, 160, 88, 1);
}

/* Анимация выезда и исчезания */
@keyframes loginForm_slideToast__rBdIC {
  0% {
    transform: translateY(100px);
    opacity: 0;
  }
  10% {
    transform: translateY(0);
    opacity: 1;
  }
  80% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(100px);
    opacity: 0;
  }
}

.loginForm_passwordWrapper__WnJaQ {
  position: relative;
  width: 100%;
  margin-bottom: 16px;
}

.loginForm_showPasswordBtn__SN3Mw {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 20px;
  color: rgba(115, 115, 115, 1);
}

`, "",{"version":3,"sources":["webpack://./src/styles/loginForm.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,aAAa;EACb,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,mCAAmC;EAC9C,mBAAmB,EAAE,2BAA2B;EAChD,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,oDAAmC;EACnC,0CAA0C;AAC5C;;AAEA,WAAW;AACX;EACE,sCAAsC;AACxC;;AAEA,UAAU;AACV;EACE,sCAAsC;AACxC;;AAEA,gCAAgC;AAChC;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;EACA;IACE,4BAA4B;IAC5B,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,6BAA6B;AAC/B","sourcesContent":[".form {\n  max-width: 360px;\n  margin: 100px auto;\n  padding: 32px 40px;\n  background-color: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n}\n\n.logo {\n  width: 140px;\n  object-fit: contain;\n  margin: 0 auto 32px auto;\n  display: block;\n}\n\n.title {\n  text-align: center;\n  color: rgba(33, 33, 33, 1);\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 24px;\n}\n\n.input {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid rgba(203, 213, 225, 1);\n  border-radius: 8px;\n  font-size: 15px;\n  transition: border-color 0.2s;\n  text-align: left;\n  background-color: none;\n  margin-bottom: 24px;\n}\n.inputs {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid rgba(203, 213, 225, 1);\n  border-radius: 8px;\n  font-size: 15px;\n  transition: border-color 0.2s;\n  text-align: left;\n  background-color: none;\n}\n.inputSecond {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid rgba(203, 213, 225, 1);\n  border-radius: 8px;\n  font-size: 15px;\n  transition: border-color 0.2s;\n  text-align: left;\n  background-color: none;\n  margin-bottom: 8px;\n}\n\n.input:focus {\n  border-color: #2e7d32;\n  background-color: #fff;\n  outline: none;\n}\n\n.button {\n  padding: 12px;\n  background-color: rgba(24, 160, 88, 1);\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  margin-bottom: 32px;\n}\n\n.button:hover {\n  background-color: #1b5e20;\n}\n\n.error {\n  color: red;\n  font-size: 14px;\n  text-align: left;\n  margin-top: -2px;\n  margin-bottom: 10px;\n}\n\n::placeholder {\n  color: rgba(201, 201, 205, 1);\n}\n\n.forgetPassword {\n  text-align: right;\n  font-size: 14px;\n  color: rgba(115, 115, 115, 1);\n  margin-bottom: 20px;\n  cursor: pointer;\n}\n\n.register {\n  color: rgba(24, 160, 88, 1);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n/* Контейнер для уведомлений по центру снизу */\n.toast-container {\n  position: fixed;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: column;\n  gap: 10px; /* расстояние между уведомлениями */\n  align-items: center; /* центрируем уведомления */\n  z-index: 9999;\n}\n\n/* Базовый стиль уведомления */\n.toast {\n  min-width: 300px;\n  max-width: 400px;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-weight: 500;\n  color: #fff;\n  opacity: 0;\n  animation: slideToast 4.5s forwards;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);\n}\n\n/* Ошибка */\n.toast.error {\n  background-color: rgba(255, 59, 48, 1);\n}\n\n/* Успех */\n.toast.success {\n  background-color: rgba(24, 160, 88, 1);\n}\n\n/* Анимация выезда и исчезания */\n@keyframes slideToast {\n  0% {\n    transform: translateY(100px);\n    opacity: 0;\n  }\n  10% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n  80% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(100px);\n    opacity: 0;\n  }\n}\n\n.passwordWrapper {\n  position: relative;\n  width: 100%;\n  margin-bottom: 16px;\n}\n\n.showPasswordBtn {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-size: 20px;\n  color: rgba(115, 115, 115, 1);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `loginForm_form__AR0O2`,
	"logo": `loginForm_logo__bYz8Y`,
	"title": `loginForm_title__z4YAH`,
	"input": `loginForm_input__SKRZ5`,
	"inputs": `loginForm_inputs__QHdVf`,
	"inputSecond": `loginForm_inputSecond__LYhDv`,
	"button": `loginForm_button__8898g`,
	"error": `loginForm_error__PQnV1`,
	"forgetPassword": `loginForm_forgetPassword__hK+mM`,
	"register": `loginForm_register__D90yr`,
	"toast-container": `loginForm_toast-container__Ju0dK`,
	"toast": `loginForm_toast__OAMN3`,
	"slideToast": `loginForm_slideToast__rBdIC`,
	"success": `loginForm_success__123Zq`,
	"passwordWrapper": `loginForm_passwordWrapper__WnJaQ`,
	"showPasswordBtn": `loginForm_showPasswordBtn__SN3Mw`
};
export default ___CSS_LOADER_EXPORT___;
